import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ['landingImage', 'abstract', 'jobMetrics', 'appMetrics', 'recentPosts']

  connect() {
    // handle abstract image animation on page load
    this.abstractTargets.forEach(element => {
      if (element.id === 'homepage_abstract_top') {
        element.classList.add('home_page_abstract_1-enter-done');
      } else if (element.id === 'homepage_abstract_bottom') {
        element.classList.add('home_page_abstract_2-enter-done');
      }
    });

    // handle navbar animation on scroll
    window.addEventListener("scroll", this.updateNavbarClasses.bind(this));

    // handle abstact image animation on scroll
    window.addEventListener("scroll", this.updateAbstractClasses.bind(this));

    // handle stock image animation on visible intersection
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0.1 });
    this.landingImageTargets.forEach(element => this.observer.observe(element));

    // Create a separate observer for job metrics
    this.jobMetricsObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // If the element is intersecting, animate the count
          this.animateCount(entry);
          // Unobserve the element after it has been triggered
          this.jobMetricsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    // Observe job metrics elements
    this.jobMetricsTargets.forEach(element => this.jobMetricsObserver.observe(element));

    // Create a separate observer for app metrics
    this.appMetricsObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // If the element is intersecting, animate the count
          this.animateCount(entry);
          // Unobserve the element after it has been triggered
          this.appMetricsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    // Observe job metrics elements
    this.appMetricsTargets.forEach(element => this.appMetricsObserver.observe(element));

    // Loop through the recent post items and show them one by one on the landing page
    this.showNextItem();

    // console.log('Landing controller connected...');
  }
  disconnect() {
    this.landingImageTargets.forEach(element => this.observer.unobserve(element));
    window.removeEventListener("scroll", this.updateNavbarClasses.bind(this));
    window.removeEventListener("scroll", this.updateAbstractClasses.bind(this));
    this.jobMetricsTargets.forEach(element => this.observer.unobserve(element));
    this.appMetricsTargets.forEach(element => this.observer.unobserve(element));
  }


  // handle animation of recent posts on landing page
  showNextItem(index = 0) {
    const items = this.recentPostsTargets;
    if (items.length === 0) return;

    // Hide the previous item
    if (index > 0) {
      items[index - 1].classList.add("hidden");
    }

    // Show the current item
    const item = items[index];
    item.classList.remove("hidden");

    // Increment the index
    index++;
    // If we've shown all items, reset the index to 0
    if (index >= items.length) {
      index = 0;
    }

    const timeout = index === 0 ? 0 : 5000;
    setTimeout(() => {
      this.showNextItem(index); // Recursively call to show the next item
    }, timeout); // Adjust the timeout to match your animation duration
  }

  // handle animation of job metrics on landing page
  animateCount(entry) {
    const element = entry.target;
    const targetDiv = element.querySelector('#jobMetricsVal') || element.querySelector('#appMetricsVal');
    let targetVal = targetDiv;

    if (targetVal === null || targetVal === undefined && element.textContent) {
      targetVal = element;
    }
    if (targetVal) {
      const target = element;
      const count = parseInt(targetVal.textContent.replace(/,/g, ''));
      const duration = 2000; // Duration of the animation in milliseconds
      const steps = Math.ceil(duration / 10); // Calculate the number of steps, one step every 10 milliseconds
      let currentStep = 0;
      const timer = setInterval(() => {
        currentStep++;
        // Use an "ease out" function to calculate the current value
        const progress = currentStep / steps; // Progress goes from 0 to 1 over the course of the animation
        const easeOutProgress = Math.sin((progress * Math.PI) / 2); // Ease out progress goes from 0 to 1, starting quickly and slowing down
        const currentValue = Math.ceil(count * easeOutProgress);
        target.textContent = currentValue.toLocaleString();
        if (currentStep >= steps) {
          target.textContent = targetVal.textContent; // Set the final value to the original value
          clearInterval(timer);
        }
      }, 10); // Run the interval every 10 milliseconds
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('more_details_img-enter-done');
      } else {
        entry.target.classList.remove('more_details_img-enter-done');
      }
    })
  }

  updateNavbarClasses() {
    const scrollY = window.scrollY;
    const navbar = document.getElementById('navbar-header');
    if (scrollY > 0) {
      navbar.classList.add('header_opaque');
      navbar.classList.add('header_scrolling');
    } else {
      navbar.classList.remove('header_opaque');
      navbar.classList.remove('header_scrolling');
    }
 }

  updateAbstractClasses() {
    const scrollY = window.scrollY;
    this.abstractTargets.forEach((element) => {
      if (scrollY > 0) {
        if (element.id === 'homepage_abstract_top') {
          element.classList.remove('home_page_abstract_1-enter-done');
          element.classList.add('home_page_abstract_1-exit-done');
        }
        else if (element.id === 'homepage_abstract_bottom') {
          element.classList.remove('home_page_abstract_2-enter-done');
          element.classList.add('home_page_abstract_2-exit-done');
        }
      } else {
        if (element.id === 'homepage_abstract_top') {
          element.classList.remove('home_page_abstract_1-exit-done');
          element.classList.add('home_page_abstract_1-enter-done');
        }
        else if (element.id === 'homepage_abstract_bottom') {
          element.classList.remove('home_page_abstract_2-exit-done');
          element.classList.add('home_page_abstract_2-enter-done');
        }
      }
    });
  }
}
